import { MerchantsComponent } from './../merchants/merchants.component';
import {
  Component,
  Injector,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { ACHFundingInfo } from '../../data/ACHFundingInfo';
import { ReplenishMethods } from '../../data/ReplenishMethods';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  AbstractControl
} from '@angular/forms';
import * as customValidator from '../../validators/ach-validator';
import { CustomerAccount } from '../../data/CustomerAccount';
import { NCConstants } from '../../data/NCConstants';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-merchant-ach-funding',
  templateUrl: './merchant-ach-funding.component.html',
  styleUrls: ['./merchant-ach-funding.component.css']
})
export class MerchantAchFundingComponent
  extends MerchantsComponent
  implements OnInit
{
  achFundingInfo: ACHFundingInfo;
  dataLoading = false;
  tableLoading = false;
  replenishMethods: ReplenishMethods;
  customerAccount: CustomerAccount;
  minACHDate: Date;
  maxACHDate: Date;
  bankAccountNumberPlaceholder: string;
  achDeclineCountNewOption: number;
  savingLinkedAccount = false;
  saving = false;
  achFunds: any[] = [];
  payRollAccount: any;
  achFundForm: UntypedFormGroup;
  achHistoryForm: UntypedFormGroup;
  loadingData = false;
  loadingHistory = false;
  transfer_ach_btn_spinner = '';
  fundType = 'N';
  fundAmt: number = null;
  applyBalanceButtonSpinnerString = '';
  bankAddress = { city: '', state: '', zip: '' };
  fundRefunds = [
    { id: 'N', value: 'Not Requested' },
    { id: 'funding', value: 'Request Funding' },
    { id: 'refund', value: 'Request Refund' }
  ];
  startDate: NgbDate;
  endDate: NgbDate;

  @ViewChild('transferButton', { static: false }) transButton: ElementRef;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.loadingData = true;
    this.merchantService
      .getMerchantAchFundingInfo(
        this.merchant.location,
        this.merchant.ncMerchantNum
      )
      .subscribe(
        (data) => {
          this.loadingData = false;
          this.achFundingInfo = data;
          this.payRollAccount = this.achFundingInfo.payRollAccount;
          this.replenishMethods = this.achFundingInfo.replenishMethods;
          this.customerAccount = this.achFundingInfo.customerAccount;
          if (this.achFundingInfo.bankAddress !== null) {
            this.bankAddress = this.achFundingInfo.bankAddress;
          }
          if (
            this.achFundingInfo.customerAccount.achDeclineCount !== 0 &&
            this.achFundingInfo.customerAccount.achDeclineCount !== 99
          ) {
            this.achDeclineCountNewOption =
              this.achFundingInfo.customerAccount.achDeclineCount;
          }
          if (
            this.achFundingInfo.replenishMethods !== null &&
            this.achFundingInfo.replenishMethods.srcAcctNum !== undefined
          ) {
            this.bankAccountNumberPlaceholder =
              this.achFundingInfo.replenishMethods.srcAcctNum;
          }
          if (this.replenishMethods === null) {
            const replenish = <ReplenishMethods>{};
            replenish.isActive = 'N';
            replenish.srcAcctName = '';
            replenish.srcABANum = '';
            replenish.srcAcctNum = '';
            replenish.srcAcctType = 'C';
            replenish.srcORGType = 'C';
            this.replenishMethods = replenish;
          }
          this.achFundingInfo.fundRefund = 'N';
          this.setData();
          this.loadingHistory = true;
          this.reloadAchHistory();
        },
        () => {
          this.messageService.error('Cannot load funding information');
          this.loadingData = false;
        }
      );
    this.initForms();
  }

  setData() {
    this.achFundForm.patchValue({
      achAllowed: this.customerAccount.achAllowed,
      srcAcctName: this.replenishMethods.srcAcctName,
      srcABANum: this.replenishMethods.srcABANum,
      srcAcctNum: this.replenishMethods.srcAcctNum,
      status: this.replenishMethods.isActive,
      achDeclineCount: this.customerAccount.achDeclineCount,
      srcAcctType: this.replenishMethods.srcAcctType,
      srcORGType: this.replenishMethods.srcORGType
    });

    this.achFundForm.controls['achAllowed'].valueChanges.subscribe((val) => {
      this.achFundingInfo.customerAccount.achAllowed = val;
      if (this.achFundingInfo.replenishMethods === null) {
        this.achFundingInfo.replenishMethods = {
          isActive: 'N'
        };
      }
      if (val === 'N') {
        this.achFundForm.controls['srcAcctName'].clearValidators();
        this.achFundForm.controls['srcAcctName'].updateValueAndValidity();
        this.achFundForm.controls['srcABANum'].clearValidators();
        this.achFundForm.controls['srcABANum'].updateValueAndValidity();
        this.achFundForm.controls['srcAcctNum'].clearValidators();
        this.achFundForm.controls['srcAcctNum'].updateValueAndValidity();
      } else {
        this.achFundForm.controls['srcAcctName'].setValidators([
          customValidator.srcAcctNameValidator,
          Validators.required,
          Validators.maxLength(22)
        ]);
        this.achFundForm.controls['srcAcctName'].updateValueAndValidity();
        this.achFundForm.controls['srcABANum'].setValidators([
          customValidator.routingNumberValidator,
          Validators.required,
          Validators.maxLength(9)
        ]);
        this.achFundForm.controls['srcABANum'].updateValueAndValidity();
        this.achFundForm.controls['srcAcctNum'].setValidators([
          customValidator.srcAcctNumValidator,
          Validators.required,
          Validators.maxLength(16)
        ]);
        this.achFundForm.controls['srcAcctNum'].updateValueAndValidity();
      }
    });

    this.achFundForm.controls['status'].valueChanges.subscribe((val) => {
      this.achFundingInfo.replenishMethods.isActive = val;
    });
  }

  initForms() {
    this.endDate = this.calendar.getToday();
    this.startDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - 90);
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      1
    );

    this.achFundForm = new UntypedFormGroup({
      achAllowed: new UntypedFormControl('', []),
      srcAcctName: new UntypedFormControl('', []),
      srcABANum: new UntypedFormControl('', []),
      srcAcctNum: new UntypedFormControl('', []),
      status: new UntypedFormControl('', []),
      achDeclineCount: new UntypedFormControl('', []),
      srcAcctType: new UntypedFormControl('', []),
      srcORGType: new UntypedFormControl('', []),
      bankCity: new UntypedFormControl('', []),
      bankState: new UntypedFormControl('', []),
      bankZip: new UntypedFormControl('', [])
    });

    this.achHistoryForm = new UntypedFormGroup({
      tranMinDate: new UntypedFormControl(this.startDate, []),
      tranMaxDate: new UntypedFormControl(this.endDate, [])
    });
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  canViewLinkedBankAccountInfo() {
    return this.hasEntitlement('MERCHANTS_ACHFUNDING_LINKED_BANK_ACCOUNT');
  }

  canUpdateAchFunding() {
    return this.hasEntitlement('MERCHANTS_ACHFUNDING_UPDATE');
  }

  reloadAchHistory() {
    this.tableLoading = true;
    this.startDate = this.achHistoryForm.value['tranMinDate'];
    this.endDate = this.achHistoryForm.value['tranMaxDate'];
    const sdDate =
      this.startDate.month +
      '/' +
      this.startDate.day +
      '/' +
      this.startDate.year;
    const edDate =
      this.endDate.month + '/' + this.endDate.day + '/' + this.endDate.year;
    this.merchantService
      .showAchRequestHistory(this.payRollAccount, sdDate, edDate)
      .subscribe(
        (data: any[]) => {
          this.achFunds = data;
          this.tableLoading = false;
          this.loadingHistory = false;
        },
        () => {
          this.messageService.error('Could not load history');
          this.tableLoading = false;
          this.loadingHistory = false;
        }
      );
    // ensure replenishMethods not null and isActive set by default
    if (this.achFundingInfo.replenishMethods === null) {
      this.achFundingInfo.replenishMethods = {
        isActive: 'N'
      };
    }
  }

  achTransfer() {
    this.transfer_ach_btn_spinner = 'fa fa-spinner';
    this.getData();
    if (this.fundType === 'N' || this.fundAmt === null || this.fundAmt <= 0) {
      return;
    } else {
      this.achFundingInfo.fundRefund = this.fundType;
      this.achFundingInfo.fundAmt = this.fundAmt;
      this.merchantService
        .updateACHFundingInfo(
          this.merchant.ncMerchantNum.toString(),
          this.merchant.location,
          this.achFundingInfo
        )
        .subscribe(
          () => {
            this.transfer_ach_btn_spinner = '';
            this.messageService.success('Successfully saved ACH transfer');
            this.fundAmt = null;
            this.fundType = 'N';
            this.loadingHistory = true;
            this.reloadAchHistory();
          },
          (error) => {
            this.saving = false;
            if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
              this.messageService.error(
                'Could not perform ACH transfer: ' + error.error
              );
            } else {
              this.messageService.error(error.message);
            }
            this.transfer_ach_btn_spinner = '';
          }
        );
    }
  }

  focusTransferButton() {
    this.transButton.nativeElement.focus();
  }

  saveAchFunds() {
    this.getData();
    if (this.achFundForm.invalid && this.customerAccount.achAllowed !== 'N') {
      for (const key of Object.keys(this.achFundForm.controls)) {
        const formControl: AbstractControl = this.achFundForm.controls[key];
        if (formControl.invalid) {
          formControl.markAsTouched();
        }
      }
    } else {
      this.saving = true;
      this.merchantService
        .updateACHFundingInfo(
          this.merchant.ncMerchantNum.toString(),
          this.merchant.location,
          this.achFundingInfo
        )
        .subscribe(
          () => {
            this.saving = false;
            this.messageService.success('Successfully saved ACH details');
            this.achFundingInfo.fundRefund = 'N';
            this.achFundingInfo.fundAmt = 0;
            this.loadingHistory = true;
            this.reloadAchHistory();
          },
          (error) => {
            this.saving = false;
            if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
              this.messageService.error('Could not update ACH: ' + error.error);
            } else {
              this.messageService.error(error.message);
            }
          }
        );
    }
  }

  getData() {
    this.customerAccount.achAllowed = this.achFundForm.value['achAllowed']
      ? this.achFundForm.value['achAllowed']
      : '';
    this.customerAccount.achDeclineCount = this.achFundForm.value[
      'achDeclineCount'
    ]
      ? this.achFundForm.value['achDeclineCount']
      : '';
    this.replenishMethods.srcAcctName = this.achFundForm.value['srcAcctName']
      ? this.achFundForm.value['srcAcctName']
      : '';
    this.replenishMethods.srcABANum = this.achFundForm.value['srcABANum']
      ? this.achFundForm.value['srcABANum']
      : '';
    this.replenishMethods.srcAcctNum = this.achFundForm.value['srcAcctNum']
      ? this.achFundForm.value['srcAcctNum']
      : '';
    this.replenishMethods.isActive = this.achFundForm.value['status']
      ? this.achFundForm.value['status']
      : '';
    this.replenishMethods.srcAcctType = this.achFundForm.value['srcAcctType']
      ? this.achFundForm.value['srcAcctType']
      : '';
    this.replenishMethods.srcORGType = this.achFundForm.value['srcORGType']
      ? this.achFundForm.value['srcORGType']
      : 'C';
    this.bankAddress.city = this.achFundForm.value['bankCity']
      ? this.achFundForm.value['bankCity']
      : '';
    this.bankAddress.state = this.achFundForm.value['bankState']
      ? this.achFundForm.value['bankState']
      : '';
    this.bankAddress.zip = this.achFundForm.value['bankZip']
      ? this.achFundForm.value['bankZip']
      : '';
    this.achFundingInfo.customerAccount = this.customerAccount;
    this.achFundingInfo.replenishMethods = this.replenishMethods;
    this.achFundingInfo.bankAddress = this.bankAddress;
  }
}
